import React, { useEffect, useState } from 'react';
import imgDownloadIcon from '../assets/img/descargarIcon.png';
import imgDumpIcon from '../assets/img/eliminarIcon.png';
import { Link, useHistory, withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
	Button,
	Menu,
	MenuItem,
	Grid,
	useTheme,
	Dialog,
	withStyles,
	IconButton,
	makeStyles,
	useMediaQuery,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useSnackbar } from 'notistack';
import Modal from '../views/Firmar/FirmaRapida/Modal';
import ModalFirmaAvanzada from '../views/Firmar/FirmaAvanzada/ModalFirmaAvanzada';
import ModalGetFIleCloud from '../views/ConsultSignedDocument/ModalGetFIleCloud';
import ModalMasive from '../views/Firmar/CircuitoFirmas/modales/ModalMasive';
import {
	estamparAction,
	estamparActionS3,
	reQuickStamp,
} from '../redux/actions/SignAction';
import Loading from './Loading';
import EditIcon from '@mui/icons-material/Edit';
import DrawIcon from '@mui/icons-material/Draw';

import {
	API_HOSTNAME_AWS,
	API_HOSTNAME_AWS_LAMBDA,
	APP_KEY,
} from '../redux/types/ApiConstants';
import {
	cambiarEstadoFirmanteMasivo,
	notificar3,
} from '../redux/actions/CircuitActions';
import { LOADING } from '../redux/types/SignTypes';
import ModalFirmaMasiva from '../views/Firmar/CircuitoFirmas/modales/ModalFirmaMasiva';
import ProgressBar from './ProgressBar';
import { encriptar } from '../redux/actions/Encriptar';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const useToolbarStyles = makeStyles(theme => ({
	iconButtonDownload: {
		borderRadius: '5px',
		backgroundImage: `url(${imgDownloadIcon}) `,
		backgroundPosition: 'center',
		width: '28px !important',
		height: '28px !important',
		marginLeft: '20px !important',
	},
	buttonDelete: {
		borderRadius: '5px',
		backgroundImage: `url(${imgDumpIcon}) `,
		backgroundPosition: 'center',
		width: '28px !important',
		height: '28px !important',
		marginLeft: '5px !important',
	},
	btnDocuments: {
		backgroundColor: '#F5AE19',
		background: '#F5AE19 0% 0% no-repeat padding-box',
		borderRadius: '5px',
		opacity: 1,
		color: '#FFFFFF',
		textShadow: '0px 2px 0px #00000040',
		height: '28px',
		marginBottom: '-10px',
		paddingLeft: '5px',
		paddingRight: '6px',
		paddingTop: '2px',
		paddingBottom: '2px',
		whiteSpace: 'nowrap',
		textTransform: 'initial',
		font: 'normal normal bold 12px/12px Muli',
		marginLeft: '12px',
		width: 'auto',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
			marginLeft: '0px',
			marginTop: theme.spacing(1),
			marginBottom: '0px',
		},
		'&:hover': {
			backgroundColor: '#F5AE19', 
			cursor: 'default',
		},
	},
}));

const ButtonsSign = props => {
	const {
		style,
		responsiveMode,
		handleClickDownload,
		handleClickDelete,
		files,
		setFiles,
		isP7,
		filesSize,
		history,
		estampar,
		estamparS3,
		getUrldocuments,
		rows,
		loading,
		selected,
		refresh,
		isUniqueElectronic,
		sizeFiles,
		setOpenedRowIndex,
		tabSelected,
		onSuccessfulSign,
		user,
		url,
	} = props;
	const classes = useToolbarStyles();
	const [statusModalAvanzado, setStatusModalAvanzado] = useState(false);
	const [statusModalCloudSelect, setStatusModalCloudSelect] = useState(false);
	const [buttonWidth, setButtonWidth] = useState(
		window.innerWidth <= 1200 ? '220px' : '180px'
	);
	const [statusModal, setStatusModal] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [infoModal, setInfoModal] = useState({});
	const [s3Limit] = useState(4);
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();
	const [isModalFirmaMasivaOpen, setIsModalFirmaMasivaOpen] = useState(false);
	const [nombresDocumentosSeleccionados, setNombresDocumentosSeleccionados] =
		useState([]);
	const [loadingProgress, setLoadingProgress] = useState(false);
	const [valueProgress, setValueProgress] = useState(0);
	const theme = useTheme();
	const states = useSelector(state => state);
	const imgFirma =
		states.sign.listManuscrita.length >= 1
			? states.sign.listManuscrita[0].base64
			: false;
	const dataCert = states.sign.certificates;
	const jwt = localStorage.getItem('JWT');
	const [confirmarModal, setConfirmarModal] = useState(false);
	const [firmaTipo, setFirmaTipo] = useState(0);
	const [showElectroContent, setShowElectroContent] = useState(false);
	const [attemps, setAttemps] = useState(0);
	const rowsPending = states.consultSignedDocument.pendingSign;
	const [bandera, setBandera] = useState(false);
	const [bandera2, setBandera2] = useState(false);
	const isXs = useMediaQuery(theme.breakpoints.down('xs')); 

	const location = useLocation();
	const isHome = location.pathname === '/home';

	const handleClose = () => {
		setAnchorEl(false);
	};

	const abrirModalFirmaMasiva = () => {
		const documentosSeleccionados = selected.map(idSeleccionado => {
			const documentoEncontrado = rowsPending.find(
				row => row.id === idSeleccionado
			);
			return {
				nombre: documentoEncontrado
					? documentoEncontrado.nombrereal
					: 'Documento desconocido',
				esCarpeta:
					documentoEncontrado &&
					documentoEncontrado.documentos &&
					documentoEncontrado.documentos.length > 1,
			};
		});
		setNombresDocumentosSeleccionados(documentosSeleccionados);
		setIsModalFirmaMasivaOpen(true);
	};

	const handleSelectedId = (
		selectedId,
		claveCertificado,
		electronica,
		password
	) => {
		// Aquí puedes manejar el ID seleccionado
		setValueProgress(45);
		// Luego puedes usar este ID para cualquier lógica que necesites
		firmar(selectedId, claveCertificado, electronica, password);
	};

	const cerrarModalFirmaMasiva = () => {
		setIsModalFirmaMasivaOpen(false);
	};

	const confirmarFirmaMasiva = () => {
		// Aquí agregas la lógica para manejar la confirmación de la firma masiva
		cerrarModalFirmaMasiva();
		// Por ejemplo, podrías llamar a `consultarCircuitos` aquí o alguna otra función

		setConfirmarModal(true);
	};

	window.addEventListener(
		'resize',
		function (event) {
			const size = document.getElementById('buttonSign');
			if (size != null)
				setButtonWidth(
					document.getElementById('buttonSign').getBoundingClientRect().width
				);
		},
		true
	);

	useEffect(() => {
		if (bandera2) {
			window.location.reload();
		}
	}, [bandera2]);

	const handleClickItem = (ltv, estampa) => {
		handleClose();
		setInfoModal({
			ltv: Boolean(ltv),
			estampa: Boolean(estampa),
			files,
		});
		setStatusModal(true);
	};

	const onClose = type => {
		setStatusModalAvanzado(false);
		setStatusModal(false);
		if (refresh != undefined) refresh(type);
		setConfirmarModal(false);
	};

	const handleEstampar = () => {
		const data = {
			documentos: files,
		};
		if (!style) {
			if (filesSize > s3Limit * 1024) {
				estamparS3(data, enqueueSnackbar, history);
			} else {
				estampar(data, enqueueSnackbar, history);
			}
		} else {
			let selectFiles = [];
			selected.map(sel => {
				let file = rows.find(x => x.id === sel);
				selectFiles.push(file);
			});
			getUrldocuments(selectFiles, enqueueSnackbar, history, onClose);
		}

		handleClose();
	};

	const consultarCircuitos = async () => {
		const url = API_HOSTNAME_AWS + 'webCircuit/api/Signatory';

		if (!jwt) {
			console.error('No se encontró el token JWT en el almacenamiento local');
			return;
		}

		const cuerpoSolicitud = {
			lisCircuito: selected,
			firmante: user,
			clientfirmaya: true
		};

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${jwt}`,
				},
				body: JSON.stringify(cuerpoSolicitud),
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.status}`);
			}

			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Hubo un error al actualizar el circuito', error);
		}
	};

	const estructura = (
		data,
		selectedId,
		claveCertificado,
		electronica,
		password
	) => {
		let estructuraFirma = {};
		if (!electronica) {
			estructuraFirma = {
				ltv: false,
				estampa: false,
				signerClientId: selectedId, //Certificado es lo que debemos setear, si el usuario lo cambia este se debe modificar, porque es el que enviamos
				key: encriptar(claveCertificado, APP_KEY),
				firmaelectronica: false,
				documents: [],
				idCircuit: '',
				clientfirmaya: true
			};
		} else {
			estructuraFirma = {
				signerClientId: selectedId, //Certificado es lo que debemos setear, si el usuario lo cambia este se debe modificar, porque es el que enviamos
				key: encriptar(password, APP_KEY),
				firmaelectronica: true,
				documents: [],
				idCircuit: '',
				codeId: claveCertificado,
				clientfirmaya: true
			};
		}

		for (let i = 0; i < data.documentos.length; i++) {
			const documento = data.documentos[i];
			const index = i + 1;

			let documentoTransformado = {
				uuid: index,
				fileName: documento.nombre,
				realFileName: documento.nombreReal,
				urlGet: documento.urlGet,
				urlPut: documento.urlPut,
				location: documento.location,
				listSigns: [],
				typeSignature: [],
			};

			if (documento.manuscrita && documento.manuscrita.length > 0) {
				for (let j = 0; j < documento.manuscrita.length; j++) {
					const firma = documento.manuscrita[j];

					documentoTransformado.typeSignature.push({
						id: j,
						signatureType: 'manuscrita',
						signPredefined: states.sign.listManuscrita.length >= 1 ? 0 : 1,
						addDataCert: 0,
						base64Image: imgFirma
							? imgFirma
							: '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',
						tpag: false,
						url: false,
						title: '',
						posXY: {
							pageNumber: firma.pageNumber,
							x: firma.eje_x,
							y: firma.eje_y,
							width: firma.ancho,
							height: firma.alto,
							pageWidth: firma.pageWidth,
							pageHeight: firma.pageHeight,
						},
					});
				}
			}

			estructuraFirma.documents.push(documentoTransformado);
		}

		return estructuraFirma;
	};

	const firmaMasiva = async estructura => {
		const url = `${API_HOSTNAME_AWS}signdocument/api/sign/advancedsignatures3`;

		if (!jwt) {
			console.error('No se encontró el token JWT en el almacenamiento local');
			enqueueSnackbar('Error de autenticación.', {
				variant: 'error',
				anchorOrigin: {
					vertical: 'top',
					horizontal: 'right',
				},
			});
			return false;
		}

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${jwt}`,
				},
				body: JSON.stringify(estructura),
			});

			const data = await response.json();

			if (!response.ok) {
				// Utiliza la descripción de la respuesta para el mensaje de error
				const errorDescripcion =
					data.message || 'Error desconocido';
				throw new Error(errorDescripcion);
			}

			return true;
		} catch (error) {
			console.error('Hubo un error al firmar los documentos', error);
			enqueueSnackbar(error.message, {
				variant: 'error',
				anchorOrigin: {
					vertical: 'top',
					horizontal: 'right',
				},
			});
			return false;
		}
	};

	const notificar = async firmante => {
		const idsUltimoFirmanteCircuito = rowsPending
			.filter(row => row.firmasTotal - row.firmasRealizadas === 1)
			.map(row => row.id);

		const idsLineal = rowsPending
			.filter(row => row.tipo === 'lineal')
			.map(row => row.id);

		// Inicialización del objeto lisCircuito
		let lisCircuito = {
			lisComplete: [],
			lisNolineal: [],
			lisLineal: [],
		};

		for (let i = 0; i < selected.length; i++) {
			const isSelectedInIds = idsUltimoFirmanteCircuito.includes(selected[i]);

			if (isSelectedInIds) {
				lisCircuito.lisComplete.push(selected[i]);
			} else {
				if (idsLineal.includes(selected[i])) {
					lisCircuito.lisLineal.push(selected[i]);
				} else {
					lisCircuito.lisNolineal.push(selected[i]);
				}
			}
		}

		await notificar3(jwt, lisCircuito, firmante, 3);
	};

	const firmar = async (
		selectedId,
		claveCertificado,
		electronica,
		password
	) => {
		// dispatch({ type: LOADING, payload: true });
		const data = await consultarCircuitos();
		if (!data) {
			enqueueSnackbar('Error al consultar circuitos.', {
				variant: 'error',
				anchorOrigin: {
					vertical: 'top',
					horizontal: 'right',
				},
			});

			// dispatch({ type: LOADING, payload: false });
			return;
		}

		const firmante = data.firmante.id;
		setValueProgress(75);
		const estruct = await estructura(
			data,
			selectedId,
			claveCertificado,
			electronica,
			password
		);
		const firmaExitosa = await firmaMasiva(estruct);
		setValueProgress(85);

		if (firmaExitosa) {
			await cambiarEstadoFirmanteMasivo(selected, firmante, jwt); // Actualización de estados
			setValueProgress(100);
			await notificar(firmante); // Notificaciones del circuito finalizado

			await enqueueSnackbar('Circuitos firmados exitosamente.', {
				variant: 'success',
				anchorOrigin: {
					vertical: 'top',
					horizontal: 'right',
				},
			});
			setBandera2(true);
			// setLoadingProgress(false)
		} else {
			setConfirmarModal(true)
			// dispatch({ type: LOADING, payload: false });
			setLoadingProgress(false);
		}
	};

	const StyledMenu = withStyles({
		paper: {
			border: '1.25px solid #9D9D9C',
			boxShadow: '0 3px 3px 1px #00000033',
			width: style ? '' : buttonWidth,
		},
	})(props => (
		<Menu
			elevation={0}
			getContentAnchorEl={null}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			{...props}
		/>
	));

	if (loading) return <Loading />;
	if (loadingProgress) return <ProgressBar value={valueProgress} />;

	return (
		<>
			<div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						flexDirection: 'row',
						gap: !style ? '16px' : '8px',
					}}
					className='gridButtons'
				>
					{/* <Grid item>
            <Button
              disabled={!style && !files.length}
              id="buttonSign"
              className={!style ? "btnGeneralSignIcon" : "btnQuick"}
              onClick={handleClick}
            >
              {" "}
              Firma rápida{" "}
              <ArrowDropDownIcon
                style={{ marginLeft: style ? "0px" : "10px" }}
              />
            </Button>
          </Grid> */}

					{tabSelected == 0 && (
						<Grid item>
							<Button
								// disabled={(!style && (!files.length || isP7 > 0)) || isP7 > 0}
								className={!style ? 'btnGeneralSign' : 'btnDocuments'}
								onClick={() => setStatusModalAvanzado(true)}
							>
								<Grid
									container
									alignItems='center'
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										gap: '5px',
										width: '100%',
									}}
								>
									<DrawIcon
										style={{
											width: '15px',
											height: '15px',
										}}
									/>{' '}
									Volver a firmar
								</Grid>
							</Button>
						</Grid>
					)}

					{tabSelected == 2 && (
						<div
							style={{
								display: 'flex',
								flexDirection: isXs ? 'column' : 'row',
								justifyContent: 'center',
								alignItems: 'center',
								gap: '10px',
								width: '95%',
							}}
						>
							{url && (
								<div style={{ width: isXs ? '100%' : 'auto' }}>
									<Button
										className={classes.btnDocuments}
										onClick={() => history.push(`/circuito/${url}`)}
										style={{ width: '100%' }}
									>
										<div
											style={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												gap: '5px',
												width: '100%',
											}}
										>
											<DrawIcon
												style={{
													width: '17px',
													height: '20px',
												}}
											/>
											Ver y Firmar
										</div>
									</Button>
								</div>
							)}

							<div style={{ width: isXs ? '100%' : 'auto' }}>
								<Button
									className={classes.btnDocuments}
									onClick={() => abrirModalFirmaMasiva()}
									style={{ width: '100%' }}
								>
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											gap: '5px',
											width: '100%',
										}}
									>
										<EditIcon
											style={{
												width: '15px',
												height: '15px',
											}}
										/>
										Firmar masivamente
									</div>
								</Button>
							</div>

							{isModalFirmaMasivaOpen && (
								<ModalMasive
									selectedDocumentNames={nombresDocumentosSeleccionados}
									onClose={cerrarModalFirmaMasiva}
									onConfirm={confirmarFirmaMasiva}
								/>
							)}

							{confirmarModal && (
								<ModalFirmaMasiva
									isOpen={confirmarModal}
									onClose={onClose}
									// onConfirm={firmar}
									datacer={dataCert.length >= 1 ? dataCert : false}
									onIdSelected={handleSelectedId}
									setLoadingProgress={setLoadingProgress}
									loadingProgress={setLoadingProgress}
									valueProgress={valueProgress}
									setValueProgress={setValueProgress}
									firmaTipo={firmaTipo}
									setFirmaTipo={setFirmaTipo}
									showElectroContent={showElectroContent}
									setShowElectroContent={setShowElectroContent}
									attemps={attemps}
									setAttemps={setAttemps}
									bandera={bandera}
									setBandera={setBandera}
								/>
							)}
						</div>
					)}

					{responsiveMode && (
						<>
							<Grid item>
								<IconButton
									onClick={handleClickDownload}
									className={classes.iconButtonDownload}
									data-title='Descargar'
								/>
							</Grid>

							<Grid item>
								<IconButton
									onClick={handleClickDelete}
									className={classes.buttonDelete}
									data-title='Eliminar'
								/>
							</Grid>
						</>
					)}
				</div>
				<StyledMenu
					id='simple-menu'
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
					className={'menu-signs-type'}
				>
					<MenuItem onClick={() => handleClickItem(false, false)}>
						{' '}
						Firmar{' '}
					</MenuItem>
					<MenuItem
						disabled={isP7 > 0 || isUniqueElectronic}
						onClick={() => handleEstampar()}
					>
						{' '}
						Estampar{' '}
					</MenuItem>
					<MenuItem
						disabled={isP7 > 0 || isUniqueElectronic}
						onClick={() => handleClickItem(false, true)}
					>
						{' '}
						Firmar y estampar{' '}
					</MenuItem>
				</StyledMenu>
				<Dialog
					open={statusModalAvanzado}
					onClose={onClose}
					aria-labelledby='responsive-dialog-title'
				>
					<ModalFirmaAvanzada
						isOpen={statusModalAvanzado}
						onClose={onClose}
						files={files}
						filesSize={sizeFiles}
						style={style}
						rows={rows}
						selected={selected}
						setFiles={setFiles}
						setOpenedRowIndex={setOpenedRowIndex}
					/>
				</Dialog>
				{statusModal == true && (
					<Modal
						isOpen={statusModal}
						onClose={onClose}
						info={infoModal}
						filesSize={sizeFiles}
						isP7={isP7}
						style={style}
						rows={rows}
						selected={selected}
						setStatusModal={setStatusModal}
					/>
				)}
				{statusModalCloudSelect && (
					<ModalGetFIleCloud
						isOpen={statusModalCloudSelect}
						onClose={() => setStatusModalCloudSelect(false)}
						setStatusModalCloudSelect={setStatusModalCloudSelect}
						statusModalCloudSelect={statusModalCloudSelect}
						files={files}
						setFiles={setFiles}
						sizeFiles={sizeFiles}
					/>
				)}
			</div>
		</>
	);
};

const mapStateToProps = state => ({
	loading: state.sign.loading,
	isUniqueElectronic: state.sign.isUniqueElectronic,
});

const mapDispatchToProps = {
	estampar: estamparAction,
	estamparS3: estamparActionS3,
	getUrldocuments: reQuickStamp,
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ButtonsSign)
);
